import React from 'react';
import PropTypes from 'prop-types';

import InfoTable from "./InfoTable";

import PaymentType from "./PaymentDistributionRule";

import TextDate from "components/text/TextDate";
import TextBoolean from "components/text/TextBoolean";


const GeneralSetting = ({ data }) => {
  if (!data || Object.keys(data).length === 0){
    return (
      <div/>
    );
  }
  let setting = data;

  let title = 'Grunn stillingar';

  let rows = [
    {
      title : "Kröfunúmer",
      field : "claimNumber"
    },
    {
      title : "Innheimtubyrjun",
      field : "collectionStart",
      display : (data) => { return (<TextDate value={data}/>); }
    },
    {
      title : () => {return (<span>Greiðsluráðstöfun (á kröfuhafa) <br/> Ef skuldabréf = Elsti gjalddagi fyrst)</span>)},
      field : "paymentDistributionRule",
      display : (data) => { return (<PaymentType rule={data}/>); }
    },
    {
      title : () => {return (<span>Höfuðstólsfæra vexti<br/> (Reikna vaxtavexti)</span>)},
      field : "capitalizeInterests",
      display : (data) => { return (<TextBoolean value={data}/>); }
    },
    {
      title : "Kröfuhafi er ekki FTS skilaskylda",
      field : "creditorDoesNotPayCapitalTax",
      display : (data) => { return (<TextBoolean value={data}/>); }
    },
    {
      title : "Kröfuhafi er vsk skyldur aðili",
      field : "creditorPaysVAT",
      display : (data) => { return (<TextBoolean value={data}/>); }
    },
    {
      title : "Sleppa skil fyrir FTS til lögmanns",
      field : "skipCollectionCapitalGainTaxOnLawyer",
      display : (data) => { return (<TextBoolean value={data}/>); }
    },
    {
      title : "Ráðstafa VSK alltaf",
      field : "allocateVATAlways",
      display : (data) => { return (<TextBoolean value={data}/>); }
    },
    {
      title : "Er skuldabréf",
      field : "isBond",
      display : (data) => { return (<TextBoolean value={data}/>); }
    }


  ];

  return (
     <InfoTable title={title} rows={rows} data={setting}/>
  );
};

GeneralSetting.propTypes = {
  data: PropTypes.object,
};

export default GeneralSetting;
